import { registerSheet, Sheets } from './sheets'

import { registerDialog, Dialog } from './dialog'
import { registerModal, Modals } from './modals'

import CopyrightRegistrationSheet from './upload/CopyrightRegistrationSheet.vue'
import UploadSelectOwnerSheet from './upload/UploadSelectOwnerSheet.vue'
import UploadFilesListSheet from './upload/UploadFilesListSheet.vue'
import UploadSelectFolderSheet from './upload/UploadSelectFolderSheet.vue'
import UploadConfirmSheet from './upload/UploadConfirmSheet.vue'
import UploadJurisdictionsSheet from './upload/UploadJurisdictionsSheet.vue'
import UploadPricingDetailsSheet from './upload/UploadPricingDetailsSheet.vue'
import UploadPrivacyModal from './upload/UploadPrivacy/UploadPrivacyModal.vue'
import UploadDetailsModal from './upload/UploadDetails/UploadDetailsModal.vue'
import UploadDetailsSheet from './upload/UploadDetails/UploadDetailsSheet.vue'
import CancelUploadModal from './upload/CancelUploadModal.vue'
import ConfirmUploadModal from './upload/ConfirmUploadModal.vue'
import ConfirmUploadDetailsModal from './upload/ConfirmUploadDetailsModal.vue'
import UploadJurisdictionsModal from './upload/UploadJurisdictionsModal.vue'
import NewCopyrightOwnerModal from './copyright/NewCopyrightOwner/NewCopyrightOwnerModal.vue'
import NewCopyrightOwnerSheet from './copyright/NewCopyrightOwner/NewCopyrightOwnerSheet.vue'
import SelectCopyrightOwnerSheet from './copyright/SelectCopyrightOwnerSheet.vue'
import FileActionsSheet from './file/FileActionsSheet.vue'
import FolderActionsSheet from './file/FolderActionsSheet.vue'
import ThreeDotsMenuSheet from './file/ThreeDotsMenuSheet.vue'
import ArchiveMenuSheet from './file/ArchiveMenuSheet.vue'
import NotificationMenuSheet from './misc/NotificationMenuSheet.vue'
import InfringementMenuSheet from './infringement/InfringementMenuSheet.vue'
import SearchFilterSheet from './search/SearchFilterSheet.vue'
import SearchSortSheet from './search/SearchSortSheet.vue'
import InfringementReportModal from './infringement/InfringementReport/InfringementReportModal.vue'
import InfringementReportSheet from './infringement/InfringementReport/InfringementReportSheet.vue'
import BuyReportCreditsModal from './infringement/BuyReportCredits/BuyReportCreditsModal.vue'
import BuyReportCreditsSheet from './infringement/BuyReportCredits/BuyReportCreditsSheet.vue'
import PayReportCreditsModal from './infringement/PayReportCredits/PayReportCreditsModal.vue'
import PayReportCreditsSheet from './infringement/PayReportCredits/PayReportCreditsSheet.vue'
import CreateReportModal from './infringement/CreateReport/CreateReportModal.vue'
import CreateReportSheet from './infringement/CreateReport/CreateReportSheet.vue'
import SelectCopyrightModal from './copyright/SelectCopyright/SelectCopyrightModal.vue'
import SelectCopyrightSheet from './copyright/SelectCopyright/SelectCopyrightSheet.vue'
import RemoveInfringingFileModal from './infringement/RemoveInfringingFileModal.vue'
import LeaveReportCreationModal from './infringement/LeaveReportCreationModal.vue'
import ConfirmReportCreationModal from './infringement/ConfirmReportCreationModal.vue'
import PurchaseCreditsSuccessModal from './infringement/PurchaseCreditsSuccessModal.vue'
import FlaggedMatchModal from './infringement/FlaggedMatch/FlaggedMatchModal.vue'
import FlaggedMatchSheet from './infringement/FlaggedMatch/FlaggedMatchSheet.vue'
import ShareReportModal from './infringement/ShareReport/ShareReportModal.vue'
import ShareReportSheet from './infringement/ShareReport/ShareReportSheet.vue'
import DeleteFoldersModal from './file/DeleteFoldersModal.vue'
import FolderInfoSheet from './file/FolderInfoSheet.vue'
import RenameFolderModal from './file/RenameFolder/RenameFolderModal.vue'
import RenameFolderSheet from './file/RenameFolder/RenameFolderSheet.vue'
import MoveItemsModal from './file/MoveItems/MoveItemsModal.vue'
import MoveItemsSheet from './file/MoveItems/MoveItemsSheet.vue'
import CannotDeleteFolderModal from './file/CannotDeleteFolderModal.vue'
import ConfirmMoveModal from './file/ConfirmMoveModal.vue'
import SuccessModal from './misc/SuccessModal.vue'
import ErrorModal from './misc/ErrorModal.vue'
import AddFolderModal from './file/AddFolder/AddFolderModal.vue'
import AddFolderSheet from './file/AddFolder/AddFolderSheet.vue'
import DownloadModal from './file/DownloadModal.vue'
import ProcessingDownloadModal from './file/ProcessingDownloadModal.vue'
import ArchiveFilesModal from './file/ArchiveFilesModal.vue'
import ConfirmArchiveFilesModal from './file/ConfirmArchiveFilesModal.vue'
import MakeFilesPrivateModal from './file/MakeFilesPrivateModal.vue'
import MakeFilesPublicModal from './file/MakeFilesPublicModal.vue'
import RemoveFileAccessModal from './file/RemoveFileAccessModal.vue'
import RemoveFileOwnerModal from './file/RemoveFileOwnerModal.vue'
import RemoveFileAuthorModal from './file/RemoveFileAuthorModal.vue'
import ShareModal from './file/Share/ShareModal.vue'
import ShareSheet from './file/Share/ShareSheet.vue'
import FileAccessModal from './file/FileAccess/FileAccessModal.vue'
import FileAccessSheet from './file/FileAccess/FileAccessSheet.vue'
import FileSettingsModal from './file/FileSettings/FileSettingsModal.vue'
import FileSettingsSheet from './file/FileSettings/FileSettingsSheet.vue'
import RegisterCountriesModal from './file/RegisterCountries/RegisterCountriesModal.vue'
import RegisterCountriesSheet from './file/RegisterCountries/RegisterCountriesSheet.vue'
import ConfirmRegisterCountriesModal from './file/RegisterCountries/ConfirmRegisterCountriesModal.vue'
import ConfirmRegisterCountriesSheet from './file/RegisterCountries/ConfirmRegisterCountriesSheet.vue'
import FilePrivacySettingsModal from './file/FilePrivacySettings/FilePrivacySettingsModal.vue'
import FilePrivacySettingsSheet from './file/FilePrivacySettings/FilePrivacySettingsSheet.vue'
import FileOwnersModal from './file/FileOwners/FileOwnersModal.vue'
import FileOwnersSheet from './file/FileOwners/FileOwnersSheet.vue'
import FileAuthorsModal from './file/FileAuthors/FileAuthorsModal.vue'
import FileAuthorsSheet from './file/FileAuthors/FileAuthorsSheet.vue'
import UpdateFilePrivacyModal from './file/UpdateFilePrivacy/UpdateFilePrivacyModal.vue'
import UpdateFilePrivacySheet from './file/UpdateFilePrivacy/UpdateFilePrivacySheet.vue'
import CopyrightInfoModal from './file/CopyrightInfo/CopyrightInfoModal.vue'
import CopyrightInfoSheet from './file/CopyrightInfo/CopyrightInfoSheet.vue'
import RegistrationsModal from './misc/Registrations/RegistrationsModal.vue'
import RegistrationsSheet from './misc/Registrations/RegistrationsSheet.vue'
import ChangeNameModal from './account/ChangeName/ChangeNameModal.vue'
import ChangeNameSheet from './account/ChangeName/ChangeNameSheet.vue'
import ChangeEmailModal from './account/ChangeEmail/ChangeEmailModal.vue'
import ChangeEmailSheet from './account/ChangeEmail/ChangeEmailSheet.vue'
import ChangeUsernameModal from './account/ChangeUsername/ChangeUsernameModal.vue'
import ChangeUsernameSheet from './account/ChangeUsername/ChangeUsernameSheet.vue'
import ChangeTitleModal from './account/ChangeTitle/ChangeTitleModal.vue'
import ChangeTitleSheet from './account/ChangeTitle/ChangeTitleSheet.vue'
import ChangeBioModal from './account/ChangeBio/ChangeBioModal.vue'
import ChangeBioSheet from './account/ChangeBio/ChangeBioSheet.vue'
import ChangePasswordModal from './account/ChangePassword/ChangePasswordModal.vue'
import ChangePasswordSheet from './account/ChangePassword/ChangePasswordSheet.vue'
import UploadProfilePictureModal from './account/UploadProfilePictureModal.vue'
import ConfirmProfilePictureModal from './account/ConfirmProfilePictureModal.vue'
import DefaultFilePrivacyModal from './file/DefaultFilePrivacy/DefaultFilePrivacyModal.vue'
import DefaultFilePrivacySheet from './file/DefaultFilePrivacy/DefaultFilePrivacySheet.vue'
import CopyrightOwnersModal from './copyright/CopyrightOwners/CopyrightOwnersModal.vue'
import CopyrightOwnersSheet from './copyright/CopyrightOwners/CopyrightOwnersSheet.vue'
import EditCopyrightOwnerModal from './copyright/EditCopyrightOwner/EditCopyrightOwnerModal.vue'
import EditCopyrightOwnerSheet from './copyright/EditCopyrightOwner/EditCopyrightOwnerSheet.vue'
import DeleteCopyrightOwnerModal from './copyright/DeleteCopyrightOwnerModal.vue'
import DeactivateOrDeleteModal from './account/closure/DeactivateOrDelete/DeactivateOrDeleteModal.vue'
import DeactivateOrDeleteSheet from './account/closure/DeactivateOrDelete/DeactivateOrDeleteSheet.vue'
import AccountClosureInfoModal from './account/closure/AccountClosureInfo/AccountClosureInfoModal.vue'
import AccountClosureInfoSheet from './account/closure/AccountClosureInfo/AccountClosureInfoSheet.vue'
import ConfirmAccountClosureModal from './account/closure/ConfirmAccountClosureModal.vue'
import AccountClosedModal from './account/closure/AccountClosedModal.vue'
import NoticeModal from './misc/NoticeModal.vue'
import MaintenanceModal from './misc/MaintenanceModal.vue'
import CancelPlanModal from './billing/CancelPlan/CancelPlanModal.vue'
import CancelPlanSheet from './billing/CancelPlan/CancelPlanSheet.vue'
import ConfirmCancelPlanModal from './billing/ConfirmCancelPlanModal.vue'
import SelectPlanBillingModal from './billing/SelectPlanBilling/SelectPlanBillingModal.vue'
import SelectPlanBillingSheet from './billing/SelectPlanBilling/SelectPlanBillingSheet.vue'
import PlanDetailsModal from './billing/PlanDetails/PlanDetailsModal.vue'
import PlanDetailsSheet from './billing/PlanDetails/PlanDetailsSheet.vue'
import UpcomingBillingDetailsModal from './billing/UpcomingBillingDetails/UpcomingBillingDetailsModal.vue'
import UpcomingBillingDetailsSheet from './billing/UpcomingBillingDetails/UpcomingBillingDetailsSheet.vue'
import ProMembershipDetailsModal from './billing/ProMembershipDetails/ProMembershipDetailsModal.vue'
import ProMembershipDetailsSheet from './billing/ProMembershipDetails/ProMembershipDetailsSheet.vue'
import AddPaymentMethodModal from './billing/AddPaymentMethod/AddPaymentMethodModal.vue'
import AddPaymentMethodSheet from './billing/AddPaymentMethod/AddPaymentMethodSheet.vue'
import ResubscribeModal from './billing/Resubscribe/ResubscribeModal.vue'
import PayModal from './billing/PayModal.vue'
import CantPayModal from './billing/CantPay/CantPayModal.vue'
import CantPaySheet from './billing/CantPay/CantPaySheet.vue'
import IAPModal from './billing/IAP/IAPModal.vue'
import IAPSheet from './billing/IAP/IAPSheet.vue'
import ResubscribeIAPModal from './billing/ResubscribeIAP/ResubscribeIAPModal.vue'
import ResubscribeIAPSheet from './billing/ResubscribeIAP/ResubscribeIAPSheet.vue'
import WelcomeToDacrProModal from './misc/WelcomeToDacrProModal.vue'
import WelcomeToDacrMembershipModal from './misc/WelcomeToDacrMembershipModal.vue'
import AllOwnersModal from './copyright/AllOwnersAuthors/AllOwnersModal.vue'
import AllOwnersSheet from './copyright/AllOwnersAuthors/AllOwnersSheet.vue'
import AllAuthorsModal from './copyright/AllOwnersAuthors/AllAuthorsModal.vue'
import AllAuthorsSheet from './copyright/AllOwnersAuthors/AllAuthorsSheet.vue'
import FromInviteModal from './misc/FromInvite/FromInviteModal.vue'
import FromInviteSheet from './misc/FromInvite/FromInviteSheet.vue'
import UploadTipModal from './upload/UploadTipModal.vue'
import ResubscribePaymentModal from './billing/Resubscribe/ResubscribePaymentModal.vue'
import ResubscribePaymentSheet from './billing/Resubscribe/ResubscribePaymentSheet.vue'
import ReportFeedbackModal from './misc/ReportFeedback/ReportFeedbackModal.vue'
import ReportFeedbackSheet from './misc/ReportFeedback/ReportFeedbackSheet.vue'
import UpdatedTermsModal from './misc/UpdatedTerms/UpdatedTermsModal.vue'
import UpdatedTermsSheet from './misc/UpdatedTerms/UpdatedTermsSheet.vue'
import DacrMembershipModal from './account/DacrMembership/DacrMembershipModal.vue'
import DacrMembershipSheet from './account/DacrMembership/DacrMembershipSheet.vue'
import UpgradeToProModal from './upgrade/UpgradeToProModal.vue'
import UpgradeBundleLimitModal from './upgrade/UpgradeBundleLimitModal.vue'

registerSheet(Sheets.CopyrightRegistration, CopyrightRegistrationSheet)
registerSheet(Sheets.UploadSelectOwner, UploadSelectOwnerSheet)
registerSheet(Sheets.UploadFilesList, UploadFilesListSheet, 'viewport')
registerSheet(Sheets.UploadSelectFolder, UploadSelectFolderSheet, 'viewport')
registerSheet(Sheets.UploadConfirm, UploadConfirmSheet, 'viewport')
registerSheet(Sheets.UploadJurisdictions, UploadJurisdictionsSheet, 'viewport')
registerSheet(
  Sheets.UploadPricingDetails,
  UploadPricingDetailsSheet,
  'viewport'
)

registerDialog(Dialog.UploadDetails, {
  modal: UploadDetailsModal,
  sheet: UploadDetailsSheet,
  height: 'viewport',
})

registerModal(Modals.CancelUpload, CancelUploadModal)
registerModal(Modals.ConfirmUpload, ConfirmUploadModal)
registerModal(Modals.UploadPrivacy, UploadPrivacyModal)
registerModal(Modals.ConfirmUploadDetails, ConfirmUploadDetailsModal)
registerModal(Modals.UploadJurisdictions, UploadJurisdictionsModal)

registerSheet(Sheets.FileActions, FileActionsSheet)
registerSheet(Sheets.FolderActions, FolderActionsSheet)
registerSheet(Sheets.ThreeDotsMenu, ThreeDotsMenuSheet)
registerSheet(Sheets.ArchiveMenu, ArchiveMenuSheet)
registerSheet(Sheets.NotificationMenu, NotificationMenuSheet)
registerSheet(Sheets.InfringementMenu, InfringementMenuSheet)
registerSheet(Sheets.SearchFilter, SearchFilterSheet)
registerSheet(Sheets.SearchSort, SearchSortSheet)

registerDialog(Dialog.InfringementReport, {
  modal: InfringementReportModal,
  sheet: InfringementReportSheet,
  height: 'viewport',
})
registerDialog(Dialog.BuyReportCredits, {
  modal: BuyReportCreditsModal,
  sheet: BuyReportCreditsSheet,
  height: 'viewport',
})
registerDialog(Dialog.PayReportCredits, {
  modal: PayReportCreditsModal,
  sheet: PayReportCreditsSheet,
  height: 'viewport',
})
registerDialog(Dialog.CreateReport, {
  modal: CreateReportModal,
  sheet: CreateReportSheet,
  height: 'viewport',
})
registerDialog(Dialog.SelectCopyright, {
  modal: SelectCopyrightModal,
  sheet: SelectCopyrightSheet,
  height: 'viewport',
})
registerDialog(Dialog.FlaggedMatch, {
  modal: FlaggedMatchModal,
  sheet: FlaggedMatchSheet,
  height: 'viewport',
})
registerDialog(Dialog.ShareReport, {
  modal: ShareReportModal,
  sheet: ShareReportSheet,
  height: 'viewport',
})

registerDialog(Dialog.NewCopyrightOwner, {
  modal: NewCopyrightOwnerModal,
  sheet: NewCopyrightOwnerSheet,
  height: 'viewport',
})

registerModal(Modals.DeleteFolders, DeleteFoldersModal)
registerSheet(Sheets.FolderInfo, FolderInfoSheet, 'viewport')
registerSheet(
  Sheets.SelectCopyrightOwner,
  SelectCopyrightOwnerSheet,
  'viewport'
)

registerDialog(Dialog.RenameFolder, {
  modal: RenameFolderModal,
  sheet: RenameFolderSheet,
  height: 'viewport',
})

registerDialog(Dialog.MoveItems, {
  modal: MoveItemsModal,
  sheet: MoveItemsSheet,
  height: 'viewport',
})

registerModal(Modals.CannotDeleteFolder, CannotDeleteFolderModal)
registerModal(Modals.ConfirmMove, ConfirmMoveModal)
registerModal(Modals.Success, SuccessModal)
registerModal(Modals.Error, ErrorModal)

registerDialog(Dialog.AddFolder, {
  modal: AddFolderModal,
  sheet: AddFolderSheet,
  height: 'viewport',
})

registerModal(Modals.Download, DownloadModal)
registerModal(Modals.ProcessingDownload, ProcessingDownloadModal)
registerModal(Modals.ArchiveFiles, ArchiveFilesModal)
registerModal(Modals.ConfirmArchiveFiles, ConfirmArchiveFilesModal)
registerModal(Modals.MakeFilesPrivate, MakeFilesPrivateModal)
registerModal(Modals.MakeFilesPublic, MakeFilesPublicModal)
registerModal(Modals.RemoveFileAccess, RemoveFileAccessModal)
registerModal(Modals.RemoveFileOwner, RemoveFileOwnerModal)
registerModal(Modals.RemoveFileAuthor, RemoveFileAuthorModal)

registerDialog(Dialog.Share, {
  modal: ShareModal,
  sheet: ShareSheet,
  height: 'viewport',
})
registerDialog(Dialog.FileAccess, {
  modal: FileAccessModal,
  sheet: FileAccessSheet,
  height: 'viewport',
})
registerDialog(Dialog.FileSettings, {
  modal: FileSettingsModal,
  sheet: FileSettingsSheet,
  height: 'viewport',
})
registerDialog(Dialog.RegisterCountries, {
  modal: RegisterCountriesModal,
  sheet: RegisterCountriesSheet,
  height: 'viewport',
})
registerDialog(Dialog.ConfirmRegisterCountries, {
  modal: ConfirmRegisterCountriesModal,
  sheet: ConfirmRegisterCountriesSheet,
})
registerDialog(Dialog.FilePrivacySettings, {
  modal: FilePrivacySettingsModal,
  sheet: FilePrivacySettingsSheet,
  height: 'viewport',
})
registerDialog(Dialog.FileOwners, {
  modal: FileOwnersModal,
  sheet: FileOwnersSheet,
  height: 'viewport',
})
registerDialog(Dialog.FileAuthors, {
  modal: FileAuthorsModal,
  sheet: FileAuthorsSheet,
  height: 'viewport',
})
registerDialog(Dialog.UpdateFilePrivacy, {
  modal: UpdateFilePrivacyModal,
  sheet: UpdateFilePrivacySheet,
  height: 'viewport',
})
registerDialog(Dialog.CopyrightInfo, {
  modal: CopyrightInfoModal,
  sheet: CopyrightInfoSheet,
  height: 'viewport',
})
registerDialog(Dialog.Registrations, {
  modal: RegistrationsModal,
  sheet: RegistrationsSheet,
})

registerDialog(Dialog.ChangeName, {
  modal: ChangeNameModal,
  sheet: ChangeNameSheet,
  height: 'viewport',
})
registerDialog(Dialog.ChangeEmail, {
  modal: ChangeEmailModal,
  sheet: ChangeEmailSheet,
  height: 'viewport',
})
registerDialog(Dialog.ChangeUsername, {
  modal: ChangeUsernameModal,
  sheet: ChangeUsernameSheet,
  height: 'viewport',
})
registerDialog(Dialog.ChangeTitle, {
  modal: ChangeTitleModal,
  sheet: ChangeTitleSheet,
  height: 'viewport',
})
registerDialog(Dialog.ChangeBio, {
  modal: ChangeBioModal,
  sheet: ChangeBioSheet,
  height: 'viewport',
})
registerDialog(Dialog.ChangePassword, {
  modal: ChangePasswordModal,
  sheet: ChangePasswordSheet,
  height: 'viewport',
})
registerDialog(Dialog.DefaultFilePrivacy, {
  modal: DefaultFilePrivacyModal,
  sheet: DefaultFilePrivacySheet,
  height: 'viewport',
})
registerDialog(Dialog.CopyrightOwners, {
  modal: CopyrightOwnersModal,
  sheet: CopyrightOwnersSheet,
  height: 'viewport',
})
registerDialog(Dialog.EditCopyrightOwner, {
  modal: EditCopyrightOwnerModal,
  sheet: EditCopyrightOwnerSheet,
  height: 'viewport',
})

registerModal(Modals.UploadProfilePicture, UploadProfilePictureModal)
registerModal(Modals.ConfirmProfilePicture, ConfirmProfilePictureModal)
registerModal(Modals.DeleteCopyrightOwner, DeleteCopyrightOwnerModal)

registerDialog(Dialog.DeactivateOrDelete, {
  modal: DeactivateOrDeleteModal,
  sheet: DeactivateOrDeleteSheet,
  height: 'viewport',
})
registerDialog(Dialog.AccountClosureInfo, {
  modal: AccountClosureInfoModal,
  sheet: AccountClosureInfoSheet,
  height: 'viewport',
})
registerModal(Modals.ConfirmAccountClosure, ConfirmAccountClosureModal)
registerModal(Modals.AccountClosed, AccountClosedModal)

registerModal(Modals.Notice, NoticeModal)
registerModal(Modals.Maintenance, MaintenanceModal)
registerModal(Modals.RemoveInfringingFile, RemoveInfringingFileModal)
registerModal(Modals.LeaveReportCreation, LeaveReportCreationModal)
registerModal(Modals.ConfirmReportCreation, ConfirmReportCreationModal)
registerModal(Modals.PurchaseCreditsSuccess, PurchaseCreditsSuccessModal)

registerDialog(Dialog.CancelPlan, {
  modal: CancelPlanModal,
  sheet: CancelPlanSheet,
  height: 'viewport',
})
registerModal(Modals.ConfirmCancelPlan, ConfirmCancelPlanModal)

registerDialog(Dialog.SelectPlanBilling, {
  modal: SelectPlanBillingModal,
  sheet: SelectPlanBillingSheet,
})

registerDialog(Dialog.PlanDetails, {
  modal: PlanDetailsModal,
  sheet: PlanDetailsSheet,
  height: 'viewport',
})

registerDialog(Dialog.UpcomingBillingDetails, {
  modal: UpcomingBillingDetailsModal,
  sheet: UpcomingBillingDetailsSheet,
  height: 'viewport',
})

registerDialog(Dialog.ProMembershipDetails, {
  modal: ProMembershipDetailsModal,
  sheet: ProMembershipDetailsSheet,
})

registerDialog(Dialog.AddPaymentMethod, {
  modal: AddPaymentMethodModal,
  sheet: AddPaymentMethodSheet,
  height: 'viewport',
})

registerModal(Modals.Resubscribe, ResubscribeModal)
registerModal(Modals.Pay, PayModal)
registerModal(Modals.AddPaymentMethod, AddPaymentMethodModal)
registerDialog(Dialog.CantPay, {
  modal: CantPayModal,
  sheet: CantPaySheet,
  height: 'viewport',
})
registerDialog(Dialog.IAP, {
  modal: IAPModal,
  sheet: IAPSheet,
  height: 'viewport',
})
registerDialog(Dialog.ResubscribeIAP, {
  modal: ResubscribeIAPModal,
  sheet: ResubscribeIAPSheet,
})
registerModal(Modals.WelcomeToDacrPro, WelcomeToDacrProModal)
registerModal(Modals.WelcomeToDacrMembership, WelcomeToDacrMembershipModal)

registerDialog(Dialog.AllOwners, {
  modal: AllOwnersModal,
  sheet: AllOwnersSheet,
})
registerDialog(Dialog.AllAuthors, {
  modal: AllAuthorsModal,
  sheet: AllAuthorsSheet,
})
registerDialog(Dialog.FromInvite, {
  modal: FromInviteModal,
  sheet: FromInviteSheet,
})
registerModal(Modals.UploadTip, UploadTipModal)
registerDialog(Dialog.ResubscribePayment, {
  modal: ResubscribePaymentModal,
  sheet: ResubscribePaymentSheet,
  height: 'viewport',
})

registerDialog(Dialog.ReportFeedback, {
  modal: ReportFeedbackModal,
  sheet: ReportFeedbackSheet,
})
registerDialog(Dialog.UpdatedTerms, {
  modal: UpdatedTermsModal,
  sheet: UpdatedTermsSheet,
})
registerDialog(Dialog.DacrMembership, {
  modal: DacrMembershipModal,
  sheet: DacrMembershipSheet,
  height: 'viewport',
})

registerModal(Modals.UpgradeToPro, UpgradeToProModal)
registerModal(Modals.UpgradeBundleLimit, UpgradeBundleLimitModal)
